import React, {Component, useEffect, useState} from 'react';
import Breadcrumb from './Breadcrumb';
import api, {headers} from '../../../api';

import Loader from 'react-spinners/RiseLoader';

const Item = ({data}) => {

    const [val, setVal] = useState(null);
    const [loading, setLoading] = useState(false);

    return (
        <form>
            <input type={"number"} onChange={e => setVal(e.target.value)} style={{maxWidth: 70}}/>
            {loading ? <p>Wait....</p> :
                <button onClick={async e => {
                    e.preventDefault();
                    if (val <= 0 || val > data.currentDebit)
                        return;

                    setLoading(true)
                    const response = await fetch(api("/collect_rider_cash"), {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify({
                            riderId: data.riderId,
                            collectedAmount: val
                        })
                    })
                    console.log(response);
                    setLoading(false);
                }} style={{border: "0px solid black"}}>Collect
                </button>
            }
        </form>
    )
}

const Content = (props) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [foods, setFoods] = useState(null);
    const [riders, setRiders] = useState(null);
    const [vendor, setVendors] = useState(null);

    const fetchFoods = async () => {
        setLoading(true);
        const ridersList = await fetch(api("/get_riders_cash_record"), {
            method: "GET",
            headers: headers,
        });
        const list = await ridersList.json();
        console.log(list);
        setRiders(list);


        const vendorList = await fetch(api("/get_vendors_cash_record"), {
            method: "GET",
            headers: headers,
        });
        const item1 = await vendorList.json();
        setVendors(item1);


        setLoading(false);
    }

    const changeStatus = async (id, block) => {
        setLoading(true);
        const response = await fetch(api("/change_user_block_status"), {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                userId: id,
                toBlock: block
            })
        });
        if (response.ok) {
            for (let i = 0; i < foods.length; i++) {
                if (foods[i].id == id) {
                    foods[i].isBlocked = block;
                    break;
                }
            }
            setFoods([...foods]);
        }
        setLoading(false);
    }

    useEffect(() => {
        fetchFoods();
    }, []);

    return (
        <>

            <div className="ms-content-wrapper">
                <div className="row">
                    <div className="col-md-12">
                        <Breadcrumb/>
                        {/* Active Orders Graph */}
                        <div className="row">


                            <div className="col-xl-6">
                                <div className="ms-panel">
                                    <div className="ms-panel-header">
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}>{loading && <Loader color={"pink"} size={20}/>}<h6
                                            style={{marginLeft: 10}}>{loading ? "Loading..." : "Rider Cash Record"}</h6>
                                        </div>
                                    </div>
                                    <div className="ms-panel-body">
                                        <div className="table-responsive">
                                            <table className="table table-hover thead-primary">
                                                <thead>
                                                <tr>
                                                    <th scope="col">Rider ID</th>
                                                    <th scope="col">Rider Name</th>
                                                    <th scope="col">Current Debit</th>
                                                    <th scope="col">Collect Amount</th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                {riders && riders.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{item.riderId}</td>
                                                        <td>{item.riderName}</td>
                                                        <td>{item.currentDebit}</td>
                                                        <td>
                                                            <Item data={item}/>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="col-xl-6">
                                <div className="ms-panel">
                                    <div className="ms-panel-header">
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}>{loading && <Loader color={"pink"} size={20}/>}<h6
                                            style={{marginLeft: 10}}>{loading ? "Loading..." : "Vendor Cash Record"}</h6>
                                        </div>
                                    </div>
                                    <div className="ms-panel-body">
                                        <div className="table-responsive">
                                            <table className="table table-hover thead-primary">
                                                <thead>
                                                <tr>
                                                    <th scope="col">Vendor ID</th>
                                                    <th scope="col">Vendor Name</th>
                                                    <th scope="col">Current Balance</th>
                                                    <th scope="col">Paid</th>
                                                    <td>Collect Amount</td>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                {vendor && vendor.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{item.vendorId}</td>
                                                        <td>{item.vendorName}</td>
                                                        <td>{item.currentBalance}</td>
                                                        <td>{item.paid}</td>
                                                        <td>
                                                            <Item data={item}/>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default Content;
